module.exports = __webpack_public_path__ + "static/img/idtroc.d627ba7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/idtroc_font/fonts/idtroc.svg?j0czor
// module id = 8fbY
// module chunks = 1